var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",class:{ active: _vm.active },on:{"click":_vm.clicked}},[_c('b-spinner',{staticClass:"loading-spinner",attrs:{"label":"Loading..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }